export const MAINTENANCE_RESPONSE_STATUS = 503

type MaintenanceResponseError = Error & {
  fatal: true
  ignoreSentry: true
  statusCode: typeof MAINTENANCE_RESPONSE_STATUS
}

export function handleMaintenanceResponse(status: number): void {
  if (status !== MAINTENANCE_RESPONSE_STATUS) {
    return
  }

  const error = createError({
    data: { maintenance: true },
    fatal: true,
    statusCode: MAINTENANCE_RESPONSE_STATUS,
    statusMessage: 'Service Unavailable',
  }) as MaintenanceResponseError
  error.ignoreSentry = true

  showError(error)

  throw error
}

export function isMaintenanceResponseError(error: unknown): boolean {
  if (!error || typeof error !== 'object') {
    return false
  }

  const responseError = error as { data?: unknown; status?: unknown; statusCode?: unknown }

  return (
    (responseError.statusCode ?? responseError.status) === MAINTENANCE_RESPONSE_STATUS &&
    hasMaintenanceMarker(responseError.data)
  )
}

function hasMaintenanceMarker(data: unknown): boolean {
  if (!data || typeof data !== 'object') {
    return false
  }

  if ('maintenance' in data && data.maintenance === true) {
    return true
  }

  const nestedData = 'data' in data ? data.data : undefined

  return Boolean(
    nestedData && typeof nestedData === 'object' && 'maintenance' in nestedData && nestedData.maintenance === true
  )
}
